import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  educationVideo: "",
  educationCategoryList: [],
  educationList: [],
  educationDetail: [],
  educationItemsList: [],
  educationItemsLessonsList: [],
  loading: false,
  error: undefined,
};

const educationSlice = createSlice({
  name: "education",
  initialState,
  reducers: {
    clearError(state) {
      state.error = undefined;
    },
    actionStart(state) {
      state.loading = true;
      state.error = undefined;
    },
    fetchEducationCategoryList(state, action) {
      state.educationCategoryList = action.payload;
      state.loading = false;
    },
    fetchEducationList(state, action) {
      state.educationList = action.payload;
      state.loading = false;
    },
    fetchEducationDetail(state, action) {
      state.educationDetail = action.payload;
      state.loading = false;
    },
    fetchEducationVideo(state, action) {
      state.educationVideo = action.payload;
      state.loading = false;
    },
    fetchEducationStart(state, action) {
      state.educationItemsList = action.payload;
      state.loading = false;
    },
    fetchEducationArchiveStart(state, action) {
      state.educationItemsLessonsList = action.payload;
      state.loading = false;
    },
  },
});

export const educationActions = educationSlice.actions;

export default educationSlice.reducer;
